import React, { useEffect, useState } from 'react';
import StaticPageTemplate from '../components/ui/StaticPageTemplate';
import styled from 'styled-components';
import { locationPageQuery } from '../queries';
import { getStaticPageData } from '../utils/staticDataLoader';

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: #2E5984;
  margin-bottom: 1rem;
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  line-height: 1.6;
  white-space: pre-line;
`;

const MapContainer = styled.div`
  width: 100%;
  height: 400px;
  margin: 2rem 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const InfoBox = styled.div`
  background-color: #f5f7fa;
  border-left: 4px solid #2E5984;
  padding: 1.5rem;
  margin: 2rem 0;
  border-radius: 0 8px 8px 0;
`;

const Location = () => {
  const [tandaraDetailsData, setTandaraDetailsData] = useState({
    streetAddress: "10 Nightingale Avenue, Sheffield, Tasmania 7306",
    phoneNumber: "03 6491 1277",
    faxNumber: "03 6491 2527",
    emailAddress: "admin@tandara.net.au"
  });

  useEffect(() => {
    const loadTandaraDetails = async () => {
      try {
        const staticData = await getStaticPageData('tandaraDetails');
        if (staticData) {
          setTandaraDetailsData(staticData);
        }
      } catch (error) {
        console.error('Error loading tandara details:', error);
      }
    };

    loadTandaraDetails();
  }, []);

  const defaultData = {
    title: "Location",
    subtitle: "Sheffield - A beautiful place",
    introText: "Tandara is located in Sheffield in North Western Tasmania within the municipality of Kentish. Sheffield (the town of murals) is also known as the gateway to Cradle Mountain.\n\nTandara is close to the town centre and enjoys an outlook toward the rugged and spectacular Mount Roland. Being situated on level land allows easy travel to the nearby shops, Mural Park and other facilities within Sheffield.\n\nTransport to Devonport (the nearest regional centre) can be arranged when required.",
    addressHeader: "Our Address",
    aboutSheffieldHeader: "About Sheffield",
    aboutSheffieldText: "Sheffield is a picturesque town located in the shadow of Mount Roland in the north-west of Tasmania. Known as the \"Town of Murals,\" Sheffield features over 140 stunning murals painted on buildings throughout the town, depicting the area's rich history and beautiful landscapes.\n\nThe town offers a relaxed country lifestyle with access to essential services, shops, cafes, and medical facilities. The surrounding area is known for its natural beauty, with Cradle Mountain-Lake St Clair National Park just a short drive away.\n\nSheffield's community is warm and welcoming, making it an ideal location for Tandara Lodge Community Care to provide its services to the elderly in a peaceful and supportive environment."
  };

  const customContent = (pageData) => (
    <>
      <MapContainer>
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2828.3861676610236!2d146.32292307670767!3d-41.38114997129825!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xaa7b0b6a7d4a3c8f%3A0x5c3b3d8d6c97f8a7!2s10%20Nightingale%20Ave%2C%20Sheffield%20TAS%207306%2C%20Australia!5e0!3m2!1sen!2sus!4v1711359000000!5m2!1sen!2sus" 
          width="100%" 
          height="100%" 
          style={{ border: 0 }} 
          allowFullScreen="" 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"
          title="Tandara Lodge Location"
        ></iframe>
      </MapContainer>
      
      <InfoBox>
        <SectionTitle>
          {pageData.addressHeader}
        </SectionTitle>
        <Paragraph>
          <strong>Tandara Lodge Community Care Inc.</strong><br />
          {tandaraDetailsData.streetAddress}
        </Paragraph>
        <Paragraph>
          <strong>Phone:</strong> {tandaraDetailsData.phoneNumber}<br />
          <strong>Fax:</strong> {tandaraDetailsData.faxNumber}<br />
          <strong>Email:</strong> {tandaraDetailsData.emailAddress}
        </Paragraph>
      </InfoBox>
      
      <Section>
        <SectionTitle>
          {pageData.aboutSheffieldHeader}
        </SectionTitle>
        <Paragraph>
          {pageData.aboutSheffieldText}
        </Paragraph>
      </Section>
    </>
  );

  return (
    <StaticPageTemplate
      pageName="locationPage"
      query={locationPageQuery}
      defaultData={defaultData}
      customContent={customContent}
    />
  );
};

export default Location;
